// extracted by mini-css-extract-plugin
export default {"game_over":"GameOver_game_over__Ep+A+","hidden":"GameOver_hidden__--6rQ","inner":"GameOver_inner__ggfkV","title":"GameOver_title__lA6DK","btn":"GameOver_btn__9WC5t"};